/* GUMA Price Range Slider | assets/guma-filter-init.js */
(function () {
  function initPriceRange() {
    document.querySelectorAll('[data-guma-price-range]').forEach(function (wrapper) {
      var slider = wrapper.querySelector('.guma-range-slider');
      if (!slider) return;

      var fill     = slider.querySelector('.guma-range-fill');
      var thumbMin = slider.querySelector('.guma-range-input--min');
      var thumbMax = slider.querySelector('.guma-range-input--max');
      var numMin   = wrapper.querySelector('.guma-price-num-min');
      var numMax   = wrapper.querySelector('.guma-price-num-max');
      var form     = wrapper.closest('form');

      var rangeMin = parseFloat(thumbMin.min) || 0;
      var rangeMax = parseFloat(thumbMin.max) || 100;

      function updateFill() {
        var minVal = parseFloat(thumbMin.value);
        var maxVal = parseFloat(thumbMax.value);
        var pMin = ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        var pMax = ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        fill.style.left  = pMin + '%';
        fill.style.width = (pMax - pMin) + '%';
      }

      updateFill();

      /* Sürüklerken input'u anlık güncelle */
      thumbMin.addEventListener('input', function () {
        var val    = parseFloat(thumbMin.value);
        var maxVal = parseFloat(thumbMax.value);
        if (val > maxVal) { thumbMin.value = maxVal; val = maxVal; }
        if (numMin) numMin.value = val;
        updateFill();
      });

      thumbMax.addEventListener('input', function () {
        var val    = parseFloat(thumbMax.value);
        var minVal = parseFloat(thumbMin.value);
        if (val < minVal) { thumbMax.value = minVal; val = minVal; }
        if (numMax) numMax.value = val;
        updateFill();
      });

      /* Bırakınca form submit */
      thumbMin.addEventListener('change', function () {
        if (numMin) numMin.value = thumbMin.value;
        if (form) form.submit();
      });
      thumbMax.addEventListener('change', function () {
        if (numMax) numMax.value = thumbMax.value;
        if (form) form.submit();
      });

      /* Number input → slider sync + submit */
      if (numMin) {
        numMin.addEventListener('change', function () {
          thumbMin.value = numMin.value;
          updateFill();
          if (form) form.submit();
        });
      }
      if (numMax) {
        numMax.addEventListener('change', function () {
          thumbMax.value = numMax.value;
          updateFill();
          if (form) form.submit();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceRange);
  } else {
    initPriceRange();
  }
})();
